import { lazy, Suspense } from 'react';
import Box from '@common/components/Box';
import DynamicImage from '@common/components/DynamicImage';
import Icon from '@common/components/Icon';
import IconSpinner from '@common/components/svgs/common/Spinner';
import Translated from '@common/components/Translated';
import { type TourStep } from '@common/types/guidedTour';

const Lottie = lazy(() => import('lottie-react'));
const lottieHeight = 160;

interface GuidedTourViewProps {
  step: TourStep;
}

function GuidedTourView({ step }: Readonly<GuidedTourViewProps>) {
  return (
    <Box my={4}>
      {step.mediaUrl && (
        <Box mb={4}>
          <DynamicImage
            placeholder={<IconSpinner size={24} />}
            alt={step.titleKey}
            src={step.mediaUrl}
            height={160}
          />
        </Box>
      )}
      {step.lottie && (
        <Box mb={4}>
          <Suspense
            fallback={(
              <div
                className="justify-content-center align-items-center"
                style={{ height: `${lottieHeight}px` }}
              >
                <Icon component={IconSpinner} size={24} />
              </div>
            )}
          >
            <Lottie
              animationData={JSON.parse(step.lottie)}
              height={lottieHeight}
              autoPlay
              loop
            />
          </Suspense>
        </Box>
      )}
      <Box mb={2} tagName="h5">
        <Translated id={step.titleKey} />
      </Box>
      <Translated id={step.messageKey} tagName="p" />
    </Box>
  );
}

export default GuidedTourView;
